<script setup lang="ts">
	import { defineProps, ref } from 'vue';
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import { Pagination, Navigation } from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/pagination';

	const modules = [Pagination, Navigation];
	const props = defineProps<{
		type: 'BULLET' | 'IMAGE';
		images: any;
		customClass?: string;
	}>();
	const pagination = ref({
		clickable: true,
		renderBullet: (index, className) => {
			return `<div class="${className}"><img src="${props.images[index]?.toString()}"/></div>`;
		},
	})

</script>
<template>
	<swiper :pagination="(type=='BULLET' || images.length===1)?false:pagination" 
			:navigation="(type=='BULLET'?true:false)"
			:modules="modules" 
			:class="['gallery-swiper', {'no-margin': type=='BULLET'}, customClass]">
		<swiper-slide v-for="(image, index) in props.images" :key="index">
			<img class="product-img" :src="image.toString()" alt="Imagen del producto" />
		</swiper-slide>
	</swiper>
</template>
<style lang="scss">
@import 'ImageSwiperComponent';
</style>
